import DateFormatter from '@/utils/DateFormatter'
export default function roomChatBotEventListener(room) {
    return (store) => {
        room.addEventListeners({
            room_chatBot_text: (chatData) => {
                let text = chatData.data.text.replace(/\[doc\d+\]/g, "");

                const dataToSave = {
                    text: text,
                    userId: chatData.userId,
                    stream: chatData.data.stream,
                    time: DateFormatter.getFormattedDate(chatData.eventTime, 'HH:mm'),
                }
                store.commit('chatBot/PUT_CHAT', dataToSave)
                store.commit('chatBot/UPDATE_SEND_STATUS', false)
            },
            room_chatBot_text_stream: (chatData) => {
                const dataToSave = {
                    type: 'bot',
                    text: chatData.data.text,
                    userId: chatData.userId,
                    stream: chatData.data.stream,
                    index: chatData.data.index,
                    isFinish: chatData.data.isFinish,
                    time: DateFormatter.getFormattedDate(chatData.eventTime, 'HH:mm'),
                }

                store.commit('chatBot/SET_STREAM_CHAT', dataToSave)
                if(dataToSave.isFinish) {
                    store.commit('chatBot/CLEAR_STREAM_CHAT')
                }
            },
        })
    }
}